// Copies the visitor identifiers that server-side purchase tracking needs into
// cart attributes. Shopify carries cart attributes into the order's
// note_attributes, and the orders/paid webhook delivers them to the server
// container, which uses them to attach the purchase to the right GA4 session
// and Meta click. Shopify webhooks carry no cookies, so without this the
// server cannot attribute a purchase at all.
//
// Writes only when a cart exists and only when a value changed since the last
// write in this tab session, so a normal page view costs no request. Never
// publishes cart-update: attributes do not change the drawer, and publishing
// would trigger a re-render.
//
// Must load after pubsub.js: subscribes to the theme cart-update event, like
// custom-atc-datalayer.js.
(function () {
  'use strict';

  var GA4_MEASUREMENT_ID = 'G-HXZ80L1H2H';
  var STORAGE_KEY = 'zf_tracking_attributes';

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    if (!m) return null;
    try {
      return decodeURIComponent(m[1]);
    } catch (e) {
      return m[1];
    }
  }

  // _ga = GA1.1.<random>.<timestamp>; GA4 uses "<random>.<timestamp>".
  function gaClientId() {
    var v = cookie('_ga');
    if (!v) return null;
    var parts = v.split('.');
    return parts.length >= 4 ? parts.slice(-2).join('.') : null;
  }

  // _ga_<id> is GS2.1.s<session_id>$o... (current format) or
  // GS1.1.<session_id>.<n>... (older format).
  function gaSessionId() {
    var v = cookie('_ga_' + GA4_MEASUREMENT_ID.replace(/^G-/, ''));
    if (!v) return null;
    var m = v.match(/^GS2\.\d+\.s(\d+)/) || v.match(/^GS1\.\d+\.(\d+)\./);
    return m ? m[1] : null;
  }

  // The Meta pixel writes _fbc when the URL has fbclid, but only after it
  // loads. Build the same value ourselves so a fast add to cart still has it.
  function fbc() {
    var v = cookie('_fbc');
    if (v) return v;
    var clickId = new URLSearchParams(window.location.search).get('fbclid');
    return clickId ? 'fb.1.' + Date.now() + '.' + clickId : null;
  }

  // Names start with _zf_ so they are easy to find in the order and do not
  // collide with app attributes. FPIDP exists only when the server Data Client
  // exposes the FPID cookie; _dcid is the Data Client's own visitor id.
  function collect() {
    var values = {
      _zf_ga_cid: gaClientId(),
      _zf_ga_sid: gaSessionId(),
      _zf_fpid: cookie('FPIDP'),
      _zf_dcid: cookie('_dcid'),
      _zf_fbp: cookie('_fbp'),
      _zf_fbc: fbc(),
    };
    var attributes = {};
    Object.keys(values).forEach(function (key) {
      if (values[key]) attributes[key] = values[key];
    });
    return attributes;
  }

  function lastWritten() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(serialized) {
    try {
      sessionStorage.setItem(STORAGE_KEY, serialized);
    } catch (e) {
      // Storage blocked: we simply write again on the next page.
    }
  }

  function write(force) {
    var attributes = collect();
    if (!Object.keys(attributes).length) return;
    var serialized = JSON.stringify(attributes);
    if (!force && serialized === lastWritten()) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (response.ok) remember(serialized);
      })
      .catch(function () {
        // Network error: the next page view or add to cart retries.
      });
  }

  // After every add, the cart exists for sure and the pixel cookies are set.
  // 'cart-items' is a quantity edit inside the drawer: same cart, nothing new.
  subscribe('cart-update', function (payload) {
    if (!payload || payload.source !== 'product-form') return;
    write(true);
  });

  // On page load, refresh the attributes of an existing cart: a visitor who
  // added to cart yesterday and buys today must carry today's session id.
  // The cart cookie exists only once a cart has been created. Wait for load
  // so the Meta pixel and the server cookies have had a chance to be set.
  window.addEventListener('load', function () {
    if (cookie('cart')) setTimeout(function () { write(false); }, 1500);
  });
})();
